import { Observable } from 'rxjs';
const DEFAULT_RECONNECT_INTERVAL = 10000;
const MAX_RECONNECT_INTERVAL = 60000;
/**
 * Default number of reconnect attempts
 * @public
 */
export const MAX_RECONNECT_ATTEMPTS = 10;
/**
 * Socket reconnection strategies
 * @public
 */
export var SocketReconnectStrategy;
(function (SocketReconnectStrategy) {
    SocketReconnectStrategy["Linear"] = "linear";
    SocketReconnectStrategy["Exponential"] = "exponential";
})(SocketReconnectStrategy || (SocketReconnectStrategy = {}));
/**
 * Generate reconnect interval based on scheduler
 * @public
 * @param reconnectOptions - {@link SocketReconnectOptions} options
 * @param scheduler - {@link SocketReconnectScheduler} function
 * @returns Observable<number>
 */
export const retryInterval = (reconnectOptions, scheduler) => {
    return new Observable((observer) => {
        let count = 0;
        let timeoutId;
        function recursiveTimeout() {
            observer.next(count);
            clearTimeout(timeoutId);
            timeoutId = setTimeout(recursiveTimeout, scheduler(reconnectOptions, count));
            count = count + 1;
        }
        recursiveTimeout();
        return () => {
            clearTimeout(timeoutId);
        };
    });
};
/**
 * Expontential Interval scheduler for reconnect
 * @public
 * @param reconnectOptions - {@link SocketReconnectOptions} options
 * @param attempt - number of attempts
 * @returns number of milliseconds that is a power of 2 ^ attempts * baseInterval
 */
export const exponentialScheduler = (reconnectOptions, attempts) => {
    const { reconnectInterval = DEFAULT_RECONNECT_INTERVAL } = reconnectOptions;
    const baseInterval = reconnectInterval > MAX_RECONNECT_INTERVAL ? MAX_RECONNECT_INTERVAL : reconnectInterval;
    const attemptsBreakPoint = Math.round(Math.log2(MAX_RECONNECT_INTERVAL / baseInterval));
    return baseInterval * Math.pow(2, (attempts % attemptsBreakPoint));
};
/**
 * Linear Interval scheduler for reconnect
 * @public
 * @param reconnectOptions - {@link SocketReconnectOptions} options
 * @returns  number of milliseconds specified in reconnectOptions up to @see MAX_RECONNECT_INTERVAL
 */
export const linearScheduler = (reconnectOptions) => {
    const { reconnectInterval = DEFAULT_RECONNECT_INTERVAL } = reconnectOptions;
    const baseInterval = reconnectInterval > MAX_RECONNECT_INTERVAL ? MAX_RECONNECT_INTERVAL : reconnectInterval;
    return baseInterval;
};
